module.exports = __webpack_public_path__ + "static/img/headtitle.99c6a60.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/headtitle.png
// module id = 5
// module chunks = 0